import { useSelector } from "react-redux"
import { selectBusinessMember } from "./businessMemberSlice"

export const useBusinessMember = () => {
  const { body, updating } = useSelector(selectBusinessMember)

  return {
    body,
    updating
  }
}